import { Routes, Route } from 'react-router-dom';
import HomePage from '../pages/Home';
import LoginPage from '../pages/Login';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      {/* Add protected routes with auth logic later */}
    </Routes>
  );
};

export default AppRoutes;
